import { create } from "zustand";
import { CartSlice, createCartSlice } from "./slices/cartSlice";
import { ModalSlice, createModalSlice } from "./slices/modalSlice";
import { PaymentSlice, createPaymentSlice } from "./slices/paymentSlice";
import { FlowSlice, createFlowSlice } from "./slices/flowSlice";

export type TransaksiStore = CartSlice & ModalSlice & PaymentSlice & FlowSlice;

export const useTransaksiStore = create<TransaksiStore>()((...a) => ({
    ...createCartSlice(...a),
    ...createModalSlice(...a),
    ...createPaymentSlice(...a),
    ...createFlowSlice(...a),
}));

// Recompute totalHarga whenever cart changes.
useTransaksiStore.subscribe((state, prev) => {
    if (state.cart !== prev.cart) {
        state.hitungHarga(state.cart);
    }
});

// Recompute grandTotal & kembalian whenever bayar/diskon/totalHarga change.
useTransaksiStore.subscribe((state, prev) => {
    if (
        state.bayar !== prev.bayar ||
        state.diskon !== prev.diskon ||
        state.totalHarga !== prev.totalHarga
    ) {
        state.hitungGrandTotal();
        state.hitungKembalian();
    }
});
